import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../services/http.service';

@Injectable()
export class FileUploaderServices {
    url = 'attachments';

    constructor(private httpService: HttpService) {
    }

    store(data, params: string[]): Observable<any> {
        return this.httpService.post(`api/${this.prepareUrl(this.url, params)}`, data, { observe: 'response' });
    }

    prepareUrl(url: string, params: string[]) {
        for (const param of params) {
            url = url.replace('@', param === null || param === undefined ? '' : param);
        }
        url = url.replace(/@/g, '');
        return url;
    }

    hasFile(fileId: string): Observable<any> {
        return this.httpService.get(`api/attachments/file/${fileId}`);
    }
}
